<template>
  <div>
    <component
      v-if="model && !loading"
      :is="fieldType"
      :block.sync="model"
      :step="step"
      v-on:update="update"
      v-on:delete="$emit('delete')"
      v-on:refresh="getBlock()"
      v-on:up="$emit('up')"
      v-on:down="$emit('down')"
    />
    <v-card v-if="loading" class="mb-5">
      <v-card-text>
        <v-row align="center" justify="center">
          <v-progress-circular :indeterminate="true" />
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import FieldCheckbox from "./Checkbox";
import FieldDate from "./Date";
import FieldRadio from "./Radio";
import FieldSelect from "./Select";
import FieldText from "./Text";
import FieldTextarea from "./Textarea";
import FieldUpload from "./Upload";
import FieldYesNo from "./YesNo";
import UndefinedField from "./UndefinedField";

import axios from "axios";
import GoogleMap from "./GoogleMap.vue";
export default {
  name: "block-field",
  components: {
    UndefinedField,
    field_checkbox: FieldCheckbox,
    field_date: FieldDate,
    field_radio: FieldRadio,
    field_select: FieldSelect,
    field_text: FieldText,
    field_textarea: FieldTextarea,
    field_upload: FieldUpload,
    field_yesno: FieldYesNo,
    field_googlemap: GoogleMap
  },
  data: () => ({
    model: null,
    loading: false
  }),
  props: {
    block: {
      type: Object,
      required: true
    },
    step: {
      type: Object,
      required: true
    }
  },
  computed: {
    fieldType: function() {
      if (this.model && this.model.fieldObject) {
        return "field_" + this.model.fieldObject.type_id;
      } else {
        return "UndefinedField";
      }
    }
  },
  mounted: function() {
    this.getBlock();
  },
  methods: {
    async getBlock() {
      this.loading = true;
      await axios
        .get(
          "service/" +
            this.step.services_id +
            "/step/" +
            this.step.id +
            "/block/" +
            this.block.id
        )
        .then(response => {
          this.model = response.data;
          this.loading = false;
        });
    },
    update(field) {
      this.$store
        .dispatch("services/updateField", {
          serviceId: this.step.services_id,
          stepId: this.step.id,
          blockId: this.model.id,
          fieldId: this.model.fieldObject.id,
          field: field
        })
        .then(() => {
          this.getBlock();
        });
    }
  }
};
</script>